import { FormGroup } from '@angular/forms';
import { ShowComponent } from '../show/show.component';

/**
 * This is the abstract edit component that can be used with Reactive forms in the edit views.
 * This class is highly recommended to use with Reactive Forms.
 */
export abstract class ReactiveDetailsComponent<T> extends ShowComponent<T> {
  /**
   * The formGroup, that is displayed.
   */
  public form: FormGroup;

  /**
   * This method extends the DetailsComponent's setModel method with the filling of the editForm part.
   */
  public beforeModelLoaded() {
    this.form = this.getForm();
    this.form.updateValueAndValidity();
  }

  /**
   * This function sets the DetailsComponent's model before uploading.
   */
  public beforeUpdate() {
    this.loadModelFromForm();
  }

  /**
   * The abstract function, that needs to be implemented in the child element. This method will returns the FormGroup from the T model.
   * @returns {FormGroup}
   * public getForm(): FormGroup {
   *    return this.model.getFormGroup();
   * }
   */
  protected abstract getForm(): FormGroup;

  /**
   * The abstract function, that needs to be implemented in the child element. This method will transform the FormGroup into the model.
   * @returns {void}
   * public loadModelFromForm(): void {
   *    this.model.loadFromFormGroup(this.form);
   * }
   */
  protected abstract loadModelFromForm(): void;
}
